var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{class:'loginbar-' + _vm.account,attrs:{"fluid":""}},[_c('b-navbar-brand',{class:'d-flex align-items-end justify-content-end logo-' + _vm.account},[_vm._v("   ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }